import { MunshiMenu } from "../components/Menu";
import React from "react";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getLevelName } from "../utilities/Authanticate";
import AnalogClock from "../components/AnalogClock";
import FirstRun from "../init/firstRun";

function Home({handle}) {
  const [user, setUser] = useState();
  const [level, setLevel] = useState("");
  const [database, setDatabase] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const userLevel = Cookies.get("level") || 1;
    setLevel(getLevelName(userLevel));
    setUser(Cookies.get("user"));
    setDatabase(Cookies.get("database") || "Test");
    setLoading(false);
  }, []);

  if (!loading) {
    return (
      <>
        <FirstRun enabled={Boolean(Cookies.get("user")) && Boolean(Cookies.get("database"))} />

        <div
          className="homePageDark flex flex-column w-full"
          style={{
            minHeight: "100vh",
            background: "#2b2f36",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div className="homePageDark__top flex flex-row justify-content-start w-full pd-10">
            <MunshiMenu handle={handle} />
          </div>

          {/* Keep content area empty/centered if you want future widgets */}
          <div className="flex-grow-1 flex align-items-center justify-content-center" />

          {/* Clock pinned to bottom-right */}
          <div
            className="homePageDark__clockWrap"
            style={{
              position: "fixed",
              right: 18,
              bottom: 18,
              zIndex: 10,
            }}
          >
            <AnalogClock size={220} showDigital variant="dark" />
          </div>
        </div>
        <div>
          {/* Home page content */}
        </div>
      </>
    );
  }
}

export default Home;